import type { Narrative } from "./types";

/**
 * Guided-browsing filtering for a narrative, whatever produced it.
 *
 * The static `fallbackNarrative` constant that used to live here is gone: the fallback copy now comes
 * from Contentful (`narrativeFromContent`), the same entries Data Science reads, so there is one
 * source of truth for the copy instead of a hand-transcribed second one.
 */

export const filterNarrativeForGuidedBrowsing = (narrative: Narrative, guidedBrowsingEnabled: boolean): Narrative => {
    const [drop, keep] = guidedBrowsingEnabled ? (["enroll", "guide"] as const) : (["guide", "enroll"] as const);

    // Drop only when the counterpart is actually there. `guide` and `enroll` are alternative
    // enrollment paths and each producer can omit either — Contentful validates every narrative field
    // EXCEPT `guide`, and the flag is read off the ProductInfo entry, so the two can legitimately
    // disagree. Filtering unconditionally would then leave the expert no enrollment path at all.
    if (!narrative.steps.some((step) => step.kind === keep)) return narrative;

    return { ...narrative, steps: narrative.steps.filter((step) => step.kind !== drop) };
};
